var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChinise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 8.33325H0.5V39.6666H47.5V8.33325Z",
    fill: "#EE1C25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33325 11.4666L11.0958 19.9689L3.86328 14.7142H12.8032L5.57066 19.9689L8.33325 11.4666Z",
    fill: "#FFFF00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7794 10.0247L16.5178 12.9932L14.9846 10.4379L17.727 11.604L14.8229 12.2725L16.7794 10.0247Z",
    fill: "#FFFF00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4242 13.5092L19.0311 16.1435L18.6097 13.1935L20.6847 15.3324L17.7488 14.8216L20.4242 13.5092Z",
    fill: "#FFFF00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7727 18.7627L18.4261 20.5996L19.2448 17.7343L20.2667 20.5335L17.7946 18.8695L20.7727 18.7627Z",
    fill: "#FFFF00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7203 20.9673L16.5821 23.9441L14.9442 21.4546L17.7326 22.506L14.8588 23.2943L16.7203 20.9673Z",
    fill: "#FFFF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChinise);
export default __webpack_public_path__ + "static/media/Chinise.0d2ab147.svg";
export { ForwardRef as ReactComponent };